import { firstValueFrom } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { enviroment } from 'src/environments/environment';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ValuationService {
  constructor(private httpClient: HttpClient) {}

  async getValuations(): Promise<any> {
    return firstValueFrom<any>(
      this.httpClient.get<any>(enviroment.url + 'valuation'),
    );
  }

  async postValuations(payload: any): Promise<any> {
    return firstValueFrom<any>(
      this.httpClient.post<any>(enviroment.url + 'valoracion', payload),
    );
  }
}
